<template>
    <div class="alert" :class="`bg-${type}`">
        <component v-if="iconComponent" class="icon alert__icon" :is="iconComponent" />

        <span class="alert__message">
            <component v-if="typeof message === 'object'" :is="message" />
            <template v-else> {{ message }} </template>
        </span>

        <span v-if="action || dismissible" class="alert__actions">
            <button
                v-if="action"
                class="btn"
                @click="
                    action.click();
                    $emit('dismiss');
                "
            >
                {{ action.label }}
            </button>

            <button
                v-if="dismissible"
                class="btn btn--transparent btn--icon"
                @click="$emit('dismiss')"
            >
                <IconX class="icon" />
            </button>
        </span>
    </div>
</template>

<script lang="ts">
import { IconAlertCircle, IconAlertTriangle, IconX } from '@tabler/icons-vue';
import { defineComponent } from 'vue';

import IconCircleCheck from '../icons/IconCircleCheck.ts';

export default defineComponent({
    name: 'Alert',

    components: {
        IconX,
    },

    props: {
        type: { type: String, default: 'emphasis' },
        icon: {},
        message: {},
        action: Object,
        dismissible: Boolean,
    },

    emits: ['dismiss'],

    computed: {
        iconComponent() {
            if (this.icon !== undefined) {
                return this.icon;
            }

            if (this.type) {
                return {
                    danger: IconAlertCircle,
                    warning: IconAlertTriangle,
                    success: IconCircleCheck,
                }[this.type];
            }
        },
    },
});
</script>
